// @ts-nocheck
/**
 * NGlow Custom Component Scripts
 * Handles dots/pagination for grids and other custom UI elements.
 */

function updateDots(containerId, gridElement) {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = '';
    for (let i = 0; i < 3; i++) {
        const dot = document.createElement('span');
        dot.className = i === 0 ? 'grid-dot active' : 'grid-dot';
        dot.addEventListener('click', () => {
            const maxScroll = gridElement.scrollWidth - gridElement.clientWidth;
            const scrollAmount = (maxScroll / 2) * i;
            gridElement.scrollTo({ left: scrollAmount, behavior: 'smooth' });
        });
        container.appendChild(dot);
    }

    gridElement.addEventListener('scroll', () => {
        const scrollPercent = gridElement.scrollLeft / (gridElement.scrollWidth - gridElement.clientWidth);
        const activeIndex = Math.round(scrollPercent * 2);
        const dots = container.querySelectorAll('.grid-dot');
        dots.forEach((dot, idx) => {
            dot.classList.toggle('active', idx === activeIndex);
        });
    });
}

document.addEventListener('NGlow:Ready', () => {
    // Initializations for custom components
    console.log("Custom UI components initialized");
});